/**
 * Detect fn
 */
export default () => 'MAX_SAFE_INTEGER' in Number
